var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SearchService from './SearchService';
import { API_ROUTES } from 'lib/workperks/common/constants';
import { axios } from "lib/Init";
import ESPerkMapper from '../models/ESPerkMapper';
const isPresent = value => {
    if (!value) {
        return false;
    }
    if (typeof value === 'string' || Array.isArray(value)) {
        return value.length > 0;
    }
    return true;
};
const EXPIRATION_THRESHOLD = 10;
const NEW_THRESHOLD = 30;
export default class ESSearchService extends SearchService {
    constructor({ user, location, resultSize = 10 }) {
        super({ user, location, resultSize });
        this.filterMethods = null;
        this.sortMethods = null;
        this.filterMethods = this.initFilters();
        this.sortMethods = this.initSort();
    }
    createPerkMapper() {
        return new ESPerkMapper(this.impressionDescriptor());
    }
    _getFilters() {
        const filters = [];
        if (!isPresent(this.showOnlineOnly) && this.redemptionType && this.redemptionType.length > 0) {
            filters.push(this.filterMethods.redemptionType(this.redemptionType));
        }
        // DEFAULT FILTERS
        // filters.push(this.filterMethods.language());
        filters.push(...this.filterMethods.campaignActive());
        filters.push(this.filterMethods.site(window.s.site.restrictedCategories));
        filters.push(this.filterMethods.restrictedAccounts(window.s.site.restrictedAccounts));
        filters.push(this.filterMethods.active());
        filters.push(this.filterMethods.date());
        isPresent(window.s.site.express) && filters.push(this.filterMethods.express());
        if (isPresent(this.showNew) && isPresent(this.showExpiringSoon)) {
            filters.push(this.filterMethods.expiringSoonAndNew());
        }
        else if (isPresent(this.showNew)) {
            filters.push(this.filterMethods.new());
        }
        else if (isPresent(this.showExpiringSoon)) {
            filters.push(this.filterMethods.expiringSoon());
        }
        else if (isPresent(this.giftCardOnly)) {
            filters.push(this.filterMethods.giftCardOnly());
        }
        isPresent(this.user.licenses) && filters.push(this.filterMethods.license());
        isPresent(this.user.parent_id) && filters.push(this.filterMethods.child());
        // SEARCH FILTERS
        // Change into a foreach? Or let every filter method decide
        // whether it gets pushed...
        isPresent(this.categoryId) && filters.push(this.filterMethods.category(this.categoryId));
        isPresent(this.subcategoryId) && filters.push(this.filterMethods.subcategory(this.subcategoryId));
        isPresent(this.location) && this.distance > 0 && filters.push(this.filterMethods.location());
        isPresent(this.visibleLocations) &&
            this.visibleLocations === true &&
            filters.push(this.filterMethods.visibleLocations());
        // !isPresent(this.showOnlineOnly) && isPresent(this.redemptionType) &&
        //   filters.push(this.filterMethods.redemptionType());
        isPresent(this.showOnlineOnly) && filters.push(this.filterMethods.onlineOnly());
        isPresent(this.tier) && filters.push(this.filterMethods.tier(this.tier));
        isPresent(this.ids) && filters.push(this.filterMethods.ids(this.ids));
        isPresent(this.label) && filters.push(this.filterMethods.label(this.label));
        isPresent(this.keyword) && filters.push(this.filterMethods.keyword(this.keyword));
        isPresent(this.account) && filters.push(this.filterMethods.account(this.account));
        return filters;
    }
    _queryObject(query) {
        if (!query || query.length === 0) {
            return { match_all: {} };
        }
        return {
            multi_match: {
                query: query,
                type: 'best_fields',
                operator: 'and',
                fields: [
                    'accountName.auto^21',
                    'accountName.folded^21',
                    'title.auto^13',
                    'title.folded^13',
                    'offer.auto^8',
                    'offer.folded^8',
                    'keywordTerms.auto^5',
                    'keywordTerms.folded^5',
                    'category.auto^3',
                    'category.folded^3',
                    'subcategory.auto^2',
                    'subcategory.folded^2',
                    'description.auto^1',
                    'description.folded^1',
                ],
            },
        };
    }
    _setSort(request) {
        request.sort = [];
        if (Object.prototype.hasOwnProperty.call(this.sortMethods, this.sort)) {
            request.sort.push(this.sortMethods[this.sort]());
        }
        if (this.sort === 'distance') {
            request.sort.push(this.sortMethods.alpha());
        }
        if (this.sort !== 'relevance' && this.sort !== 'tier') {
            request.sort.push(this.sortMethods.tier());
        }
        return request;
    }
    _buildRequest(query) {
        const queryObject = this.template ? this.template : this._queryObject(query);
        const filters = this._getFilters();
        let request = {
            size: this.resultSize,
            from: this.offset,
            _source: this.esSource,
            query: {
                bool: Object.assign(Object.assign({ must: [queryObject] }, (query && {
                    "must_not": [
                        {
                            "term": {
                                "sponsoredKeywordTerms.keyword": {
                                    "value": query,
                                    "case_insensitive": true
                                }
                            }
                        }
                    ]
                })), { filter: {
                        bool: {
                            must: filters,
                        },
                    } }),
            },
        };
        if (!this.banner && (!queryObject['multi_match'] || window.s.pageName === 'Search')) {
            request = this._setSort(request);
        }
        return request;
    }
    search(query) {
        const _super = Object.create(null, {
            search: { get: () => super.search }
        });
        return __awaiter(this, void 0, void 0, function* () {
            query = query && query.length > 0 ? query.toLowerCase() : null;
            _super.search.call(this, query);
            const request = this._buildRequest(query);
            // Prod will return 404 if there is an error, don't panic
            // thinking it's the URL...
            return axios
                .post(API_ROUTES.elasticsearch.perk, request)
                .then(response => {
                this._lastTotalHits = response.data.hits.total.value;
                return response.data.hits.hits.map(perk => perk._source);
            })
                .catch(response => {
                console.error("Error-----Res", response);
                this._lastTotalHits = 0;
            });
        });
    }
    getFavouritesDatasource(ids) {
        return { "query": { "bool": { "must": { "terms": { "id": ids } } } }, "size": 10, "from": 0 };
    }
    getAccounts(ids) {
        if (!(ids instanceof Array)) {
            throw `InputError: Given IDs '${JSON.stringify(ids)}' are not of type Array.`;
        }
        const datasource = this.getFavouritesDatasource(ids);
        datasource.size = this.resultSize;
        datasource.from = this.offset;
        return axios.post(API_ROUTES.elasticsearch.account, datasource).then(response => {
            this._lastTotalHits = response.data.hits.total.value;
            const accounts = response.data.hits.hits.map(account => account._source);
            accounts.map((obj, index) => {
                obj['source'] = 'es';
                obj['position'] = index;
                return obj;
            });
            return accounts;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }
    initSort() {
        const alphaSort = {};
        alphaSort['title.lower_case_sort'] = {
            order: 'asc',
        };
        return {
            // relevance: () => ({ _score: { order: 'desc' } }),
            distance: () => ({
                _geo_distance: {
                    'locations.pin': [
                        parseFloat(this.location.longitude),
                        parseFloat(this.location.latitude),
                    ],
                    order: 'asc',
                    unit: this.distanceUnit,
                    mode: 'min',
                    distance_type: 'arc',
                },
            }),
            alpha: () => alphaSort,
            date: () => ({ statusChanged: { order: 'desc' } }),
            tier: () => ({ tier: { order: 'asc' } }),
        };
    }
    initFilters() {
        return {
            active: () => ({ term: { statusId: 5 } }),
            license: () => {
                const licenses = this.user.licenses.filter((license) => this.location.country === 'US' ? parseInt(license) !== 1 : parseInt(license) !== 2);
                return { terms: { licenses: licenses !== null && licenses !== void 0 ? licenses : [1] } };
            },
            // Below Not needed as ES is localized
            // language: () => ({
            //     terms: { lang_filter: this.language === 'en' ? [1] : [2] },
            // }),
            category: category => ({ term: { 'category.id': category } }),
            subcategory: subcategory => ({
                terms: { 'subcategory.id': subcategory },
            }),
            date: () => ({
                bool: {
                    should: [
                        {
                            bool: {
                                must: [
                                    { term: { neverExpiring: 1 } },
                                    {
                                        range: {
                                            validFrom: {
                                                lte: 'now/d',
                                            },
                                        },
                                    },
                                ]
                            }
                        },
                        {
                            bool: {
                                must: [
                                    { term: { neverExpiring: 0 } },
                                    {
                                        range: {
                                            validFrom: {
                                                lte: 'now/d',
                                            },
                                        },
                                    },
                                    {
                                        range: {
                                            validTo: {
                                                gte: 'now/d',
                                            },
                                        },
                                    }
                                ]
                            }
                        }
                    ]
                }
            }),
            campaignActive: () => [
                {
                    range: {
                        'campaign.startDate': {
                            lte: 'now/d',
                        },
                    },
                },
                {
                    range: {
                        'campaign.endDate': {
                            gte: 'now/d',
                        },
                    },
                },
                {
                    term: {
                        'campaign.statusId': 1
                    }
                }
            ],
            tier: tier => ({
                term: { tier: tier },
            }),
            visibleLocations: () => ({ term: { 'location.visible': 1 } }),
            giftCardOnly: () => ({ term: { "account.aggregator.type": "Gift Card" } }),
            expiringSoon: () => ({
                bool: {
                    must: {
                        range: {
                            validTo: {
                                gte: 'now/d',
                                lte: `now+${EXPIRATION_THRESHOLD}d/d`,
                            },
                        },
                    },
                },
            }),
            expiringSoonAndNew: () => ({
                bool: {
                    should: [
                        {
                            bool: {
                                must: {
                                    range: {
                                        validTo: {
                                            gte: 'now/d',
                                            lte: `now+${EXPIRATION_THRESHOLD}d/d`,
                                        },
                                    },
                                },
                            },
                        },
                        {
                            bool: {
                                should: [
                                    {
                                        bool: {
                                            must: {
                                                match: {
                                                    isNew: 1
                                                }
                                            }
                                        }
                                    },
                                    {
                                        bool: {
                                            must: {
                                                range: {
                                                    validFrom: {
                                                        gt: `now-${NEW_THRESHOLD}d/d`,
                                                        lte: 'now/d',
                                                    },
                                                },
                                            }
                                        },
                                    }
                                ],
                            },
                        }
                    ],
                },
            }),
            keyword: keyword => ({
                bool: {
                    must: {
                        match: { 'keywords.id': keyword },
                    },
                },
            }),
            label: label => ({
                bool: {
                    must: {
                        match: { 'labelIds': label },
                    },
                },
            }),
            account: account => ({
                bool: {
                    must: {
                        match: { 'accountId': account },
                    },
                },
            }),
            restrictedAccounts: accountIds => ({
                bool: {
                    must_not: {
                        terms: { 'accountId': accountIds },
                    },
                },
            }),
            // Needs to be aware of express
            site: (categoryList) => ({
                bool: {
                    should: [
                        {
                            bool: {
                                should: [
                                    { term: { restrictionType: 'Globally Available' } }
                                ],
                                must_not: [
                                    { terms: { 'category.id': categoryList } },
                                    { terms: { 'subcategory.id': categoryList } }
                                ]
                            },
                        },
                        {
                            bool: {
                                should: [
                                    { term: { restrictionType: 'Hidden' } },
                                ],
                                must_not: [
                                    { term: { restrictedSites: window.s.site.id } },
                                    { terms: { 'category.id': categoryList } },
                                    { terms: { 'subcategory.id': categoryList } }
                                ]
                            },
                        },
                        {
                            bool: {
                                must: [
                                    { term: { restrictionType: 'Local' } },
                                    { term: { restrictedSites: window.s.site.id } },
                                ],
                            },
                        },
                    ],
                },
            }),
            new: () => ({
                bool: {
                    should: [
                        {
                            bool: {
                                must: {
                                    match: {
                                        isNew: 1
                                    }
                                }
                            }
                        },
                        {
                            bool: {
                                must: {
                                    range: {
                                        validFrom: {
                                            gt: `now-${NEW_THRESHOLD}d/d`,
                                            lte: 'now/d',
                                        },
                                    },
                                }
                            },
                        }
                    ],
                },
            }),
            onlineOnly: () => ({
                bool: {
                    must: [
                        {
                            exists: { field: "redemptions.online" }
                        },
                        {
                            bool: {
                                must_not: {
                                    exists: {
                                        field: "redemptions.instore"
                                    }
                                }
                            }
                        },
                        {
                            bool: {
                                must_not: {
                                    exists: {
                                        field: "redemptions.mobile"
                                    }
                                }
                            }
                        },
                        {
                            bool: {
                                must_not: {
                                    exists: {
                                        field: "redemptions.email"
                                    }
                                }
                            }
                        }
                    ]
                }
            }),
            child: () => ({
                bool: {
                    must_not: {
                        term: {
                            hideFromChildUser: 1,
                        },
                    },
                },
            }),
            banner: () => [
                {
                    term: { tier: 1 },
                },
                {
                    exists: {
                        field: 'images.heroBanner',
                    },
                },
            ],
            express: () => ({
                term: {
                    isExpress: 1
                }
            }),
            location: () => ({
                bool: {
                    should: [
                        {
                            bool: {
                                must: [
                                    {
                                        term: {
                                            redemptions: "instore"
                                        }
                                    },
                                    {
                                        bool: {
                                            must_not: {
                                                terms: {
                                                    redemptions: ["online", "mobile", "email"]
                                                }
                                            }
                                        }
                                    },
                                    {
                                        geo_distance: {
                                            distance: `${this.distance} ${this.distanceUnit}`,
                                            distance_type: "arc",
                                            "locations.pin": {
                                                lat: parseFloat(this.location.latitude),
                                                lon: parseFloat(this.location.longitude)
                                            }
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            bool: {
                                must_not: {
                                    bool: {
                                        must: [
                                            {
                                                term: {
                                                    redemptions: "instore"
                                                }
                                            },
                                            {
                                                bool: {
                                                    must_not: {
                                                        terms: {
                                                            redemptions: ["online", "mobile", "email"]
                                                        }
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                should: [
                                    {
                                        bool: {
                                            must_not: [
                                                {
                                                    exists: {
                                                        field: "locations"
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        bool: {
                                            must: [
                                                {
                                                    exists: {
                                                        field: "locations"
                                                    }
                                                },
                                                {
                                                    term: {
                                                        provinces: this.location.province
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                }
            }),
            closeBy: () => ({
                bool: {
                    should: [
                        {
                            bool: {
                                must_not: { exists: { field: 'locations' } },
                            },
                        },
                        {
                            geo_distance: {
                                distance: `${this.distance} ${this.distanceUnit}`,
                                distance_type: 'arc',
                                'locations.pin': {
                                    lat: parseFloat(this.location.latitude),
                                    lon: parseFloat(this.location.longitude),
                                },
                            },
                        },
                    ],
                },
            }),
            redemptionType: (redemption) => ({
                bool: {
                    must: {
                        terms: { redemptions: redemption }
                    }
                },
            }),
            ids: perkIds => ({
                ids: {
                    values: perkIds,
                },
            }),
            accountIds: accountIds => ({
                accountId: {
                    values: accountIds,
                },
            }),
        };
    }
    _getPerkForCategoryTile(categoryId) {
        return {
            function_score: {
                query: {
                    bool: {
                        should: [
                            {
                                bool: {
                                    must: [
                                        { match: { "category.id": categoryId } },
                                        { exists: { field: "images.logo" } },
                                        { exists: { field: "platformElements.categorySponsor.id" } },
                                        { range: { "platformElements.categorySponsor.startDate": { "lte": "now/d" } } },
                                        { range: { "platformElements.categorySponsor.endDate": { "gte": "now/d" } } },
                                    ]
                                }
                            },
                            { match: { "category.id": categoryId } }
                        ]
                    }
                },
                functions: [
                    {
                        filter: [
                            { exists: { field: "platformElements.categorySponsor.id" } },
                            { range: { "platformElements.categorySponsor.startDate": { "lte": "now/d" } } },
                            { range: { "platformElements.categorySponsor.endDate": { "gte": "now/d" } } },
                        ],
                        weight: 20
                    },
                    {
                        random_score: {}
                    }
                ]
            }
        };
    }
}
